module.exports = __webpack_public_path__ + "static/media/om_eyeshape_hooded_lightbrown.68de7c74.png";